// pages/BusquedaReservasXML.js
import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Card,
  Space,
  Typography,
  message,
  Tag,
  Row,
  Col,
  DatePicker,
  Input,
  Select,
  Statistic,
  Badge,
  Tooltip,
  Popconfirm,
  Modal,
  Form, Spin
} from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  EyeOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CalendarOutlined,
  HomeOutlined,
  BarcodeOutlined,
  UserOutlined,
  DollarOutlined,
  ExportOutlined,
  EditOutlined,
  FilterOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
import axios from 'axios';

import PageContainer from '../components/PageContainer';
import { BASE_URL } from '../utils/constants';
import { resolveTransition } from 'framer-motion';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

const BusquedaReservasXML = () => {
  // Estados
  const [reservas, setReservas] = useState([]);  
  const [estadisticas2, setEstadisticas2] = useState([]);  
  const [loading, setLoading] = useState(false);
  const [hoteles, setHoteles] = useState([]);
  const [hotelesSeleccionados, setHotelesSeleccionados] = useState([]);
  
  
  // Estados para filtros
  const [fechaEntradaDesde, setFechaEntradaDesde] = useState(null);
  const [fechaEntradaHasta, setFechaEntradaHasta] = useState(null);
  const [fechaSalidaDesde, setFechaSalidaDesde] = useState(null);
  const [fechaSalidaHasta, setFechaSalidaHasta] = useState(null);
  const [fechaReservaDesde, setFechaReservaDesde] = useState(null);
  const [fechaReservaHasta, setFechaReservaHasta] = useState(null);
  const [reservaDesde, setReservaDesde] = useState('');
  const [reservaHasta, setReservaHasta] = useState('');
  const [localizador, setLocalizador] = useState('');
  const [marcadas, setMarcadas] = useState('todas'); // 'todas', 'si', 'no'
  
  // Estados para ordenación y filtros de tabla
  const [sortedInfo, setSortedInfo] = useState({});
  const [filteredInfo, setFilteredInfo] = useState({});
  
  // Estado para edición de fecha
  const [modalFechaVisible, setModalFechaVisible] = useState(false);
  const [fechaEditando, setFechaEditando] = useState({ tipo: '', reserva: null });
  const [formFecha] = Form.useForm();
  
  // Estado para información del hotel
  const [infoHotel, setInfoHotel] = useState({ ultimaConexion: '', ultimoLocalizador: '' });

  // Añadir después de los estados existentes
  const [modalVerVisible, setModalVerVisible] = useState(false);
  const [reservaSeleccionada, setReservaSeleccionada] = useState(null);
  const [lineasReserva, setLineasReserva] = useState([]);
  const [preciosReserva, setPreciosReserva] = useState([]);
  const [loadingDetalle, setLoadingDetalle] = useState(false);  

  // Cargar datos iniciales
  useEffect(() => {
    cargarHoteles();
    // verificarEsCentral();
    // if (!esCentral) {
    //   cargarInfoHotel();
    // }
  }, []);

//   const verificarEsCentral = () => {
//     const central = localStorage.getItem('esCentral') === 'true';
//     setEsCentral(central);
//   };

  const cargarHoteles = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/hoteles/dropdown`, {
        headers: { Authorization: `Bearer ${token}` }
      });      
      
      setHoteles(response.data.data || []);
    } catch (error) {
      console.error('❌ Error cargando hoteles:', error);
    }
  };

  const cargarInfoHotel = async () => {
    try {
      const token = localStorage.getItem('token');
      const nombreHotel = localStorage.getItem('nombreHotelWeb');
      const response = await axios.get(`${BASE_URL}/api/hoteles/info/${nombreHotel}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.data) {
        setInfoHotel({
          ultimaConexion: response.data.data.UltimaConexion || '',
          ultimoLocalizador: response.data.data.UltimaReservaProcesada || ''
        });
      }
    } catch (error) {
      console.error('❌ Error cargando info hotel:', error);
    }
  };

  const buscarReservas = async () => {
    // Validar que haya hoteles seleccionados si es central
    console.log(hotelesSeleccionados.length);
    
    if (hotelesSeleccionados.length === 0) {
      message.warning('Debe seleccionar al menos un hotel');
      return;
    }

    setLoading(true);
    
    try {
      const token = localStorage.getItem('token');
      
      const params = {
        // hoteles: esCentral ? hotelesSeleccionados : [localStorage.getItem('nombreHotelWeb')],
        hoteles: hotelesSeleccionados,
        fechaEntradaDesde: fechaEntradaDesde?.format('YYYY-MM-DD'),
        fechaEntradaHasta: fechaEntradaHasta?.format('YYYY-MM-DD'),
        fechaSalidaDesde: fechaSalidaDesde?.format('YYYY-MM-DD'),
        fechaSalidaHasta: fechaSalidaHasta?.format('YYYY-MM-DD'),
        fechaReservaDesde: fechaReservaDesde?.format('YYYY-MM-DD'),
        fechaReservaHasta: fechaReservaHasta?.format('YYYY-MM-DD'),
        reservaDesde,
        reservaHasta,
        localizador,
        marcadas,
        sortField: sortedInfo.field || 'IdReserva',
        sortOrder: sortedInfo.order === 'descend' ? 'DESC' : 'ASC'
      };

      const response = await axios.post(`${BASE_URL}/api/reservasXML/buscar`, params, {
        headers: { Authorization: `Bearer ${token}` }
      });      
        
      setEstadisticas2(response.data.estadisticas)

      const datos = (response.data.data || []).map(item => ({
        ...item,
        Importe: parseFloat(item.Importe) || 0,
        CHECKINDATE: item.CHECKINDATE ? dayjs(item.CHECKINDATE) : null,
        CHECKOUTDATE: item.CHECKOUTDATE ? dayjs(item.CHECKOUTDATE) : null,
        RESERVATION_DATE: item.RESERVATION_DATE ? dayjs(item.RESERVATION_DATE) : null
      }));
      
      setReservas(datos);
      message.success(`Se encontraron ${datos.length} reservas`);
      
    } catch (error) {
      console.error('❌ Error buscando reservas:', error);
      message.error('Error al buscar reservas');
      setReservas([]);
    } finally {
      setLoading(false);
    }
  };

  const handleMarcarDesmarcar = async (record) => {
    try {
      // console.log(" record => ",record);
      
      const token = localStorage.getItem('token');
      const nuevaMarcada = record.Descargada === 'Desmarcar' ? 0 : 1;
      
      await axios.put(
        `${BASE_URL}/api/reservasXML/${record.IDReserva}/marcar`,
        { descargada: nuevaMarcada },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Actualizar estado local
      setReservas(prev => prev.map(r => 
        r.IDReserva === record.IDReserva 
          ? { ...r, Descargada: nuevaMarcada === 0 ? 'Marcar' : 'Desmarcar' }
          : r
      ));
      
      message.success('Estado actualizado correctamente');
    } catch (error) {
      console.error('❌ Error actualizando estado:', error);
      message.error('Error al actualizar el estado');
    }
  };

  const handleEditarFecha = (tipo, record) => {
    setFechaEditando({ tipo, reserva: record });
    formFecha.setFieldsValue({
      fecha: tipo === 'entrada' ? record.CHECKINDATE : record.CHECKOUTDATE
    });
    setModalFechaVisible(true);
  };

  const handleGuardarFecha = async () => {
    try {
      const values = await formFecha.validateFields();
      const token = localStorage.getItem('token');
      const { tipo, reserva } = fechaEditando;
      
      await axios.put(
        `${BASE_URL}/api/reservasXML/${reserva.IdReserva}/fecha`,
        {
          tipo,
          fecha: values.fecha.format('YYYY-MM-DD'),
          locationNumber: reserva.LOCATION_NUMBER,
          hotelId: reserva.HotelID
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      message.success('Fecha actualizada correctamente');
      setModalFechaVisible(false);
      buscarReservas(); // Refrescar datos
      
    } catch (error) {
      console.error('❌ Error guardando fecha:', error);
      message.error('Error al guardar la fecha');
    }
  };

  const handleEliminarReserva = async (record) => {
    try {
      const token = localStorage.getItem('token');
      
      await axios.delete(`${BASE_URL}/api/reservasXML/${record.IdReserva}`, {
        headers: { Authorization: `Bearer ${token}` },
        data: {
          hotelId: record.HotelID,
          locationNumber: record.LOCATION_NUMBER
        }
      });
      
      setReservas(prev => prev.filter(r => r.IdReserva !== record.IdReserva));
      message.success('Reserva eliminada correctamente');
      
    } catch (error) {
      console.error('❌ Error eliminando reserva:', error);
      message.error('Error al eliminar la reserva');
    }
  };

const handleVerReserva = async (record) => {
  console.log("Ver reserva => ", record);
  setReservaSeleccionada(record);
  setModalVerVisible(true);
  setLoadingDetalle(true);
  
  try {
    const token = localStorage.getItem('token');
    
    // Obtener líneas de la reserva
    const lineasResponse = await axios.get(`${BASE_URL}/api/reservasXML/${record.IDReserva}/lineas`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setLineasReserva(lineasResponse.data.data || []);
    
    // Obtener precios de la reserva
    const preciosResponse = await axios.get(`${BASE_URL}/api/reservasXML/${record.IDReserva}/precios`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setPreciosReserva(preciosResponse.data.data || []);
    
  } catch (error) {
    console.error('❌ Error cargando detalles:', error);
    message.error('Error al cargar los detalles de la reserva');
  } finally {
    setLoadingDetalle(false);
  }
};

  const handleResetFiltros = () => {
    setFechaEntradaDesde(null);
    setFechaEntradaHasta(null);
    setFechaSalidaDesde(null);
    setFechaSalidaHasta(null);
    setFechaReservaDesde(null);
    setFechaReservaHasta(null);
    setReservaDesde('');
    setReservaHasta('');
    setLocalizador('');
    setMarcadas('todas');
    setHotelesSeleccionados([]);
    setFilteredInfo({});
    setSortedInfo({});
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  // Configuración de columnas de la tabla
  const columns = [
    {
      title: 'Hotel',
      dataIndex: 'NombreHotel',
      key: 'NombreHotel',
      width: 150,
      sorter: (a, b) => a.NombreHotel?.localeCompare(b.NombreHotel || '') || 0,
      sortOrder: sortedInfo.columnKey === 'NombreHotel' && sortedInfo.order,
      render: (text) => (
        <Tag color="blue" icon={<HomeOutlined />}>
          {text}
        </Tag>
      ),
      filters: hoteles.map(h => ({ text: h.label, value: h.value })),
      filteredValue: filteredInfo.NombreHotel || null,
      onFilter: (value, record) => record.NombreHotel === value,
    },
    {
      title: 'ID Reserva',
      dataIndex: 'IdReserva',
      key: 'IdReserva',
      width: 100,
      sorter: (a, b) => (a.IdReserva || 0) - (b.IdReserva || 0),
      sortOrder: sortedInfo.columnKey === 'IdReserva' && sortedInfo.order,
    },
    {
      title: 'Localizador',
      dataIndex: 'LOCATION_NUMBER',
      key: 'LOCATION_NUMBER',
      width: 130,
      render: (text) => (
        <Tag color="purple">
          {text}
        </Tag>
      ),
    },
    {
      title: 'Reserva Anphitrion',
      dataIndex: 'ReservaAnphitrion',
      key: 'ReservaAnphitrion',
      width: 140,
    },
    {
      title: 'Estado',
      dataIndex: 'Status',
      key: 'Status',
      width: 110,
      render: (status) => {
        const config = {
          'Nueva': { color: 'green', icon: <CheckCircleOutlined /> },
          'Modificada': { color: 'orange', icon: <EditOutlined /> },
          'Cancelada': { color: 'red', icon: <CloseCircleOutlined /> },
        };
        const cfg = config[status] || { color: 'default' };
        return (
          <Tag color={cfg.color} icon={cfg.icon}>
            {status}
          </Tag>
        );
      },
      filters: [
        { text: 'Nueva', value: 'Nueva' },
        { text: 'Modificada', value: 'Modificada' },
        { text: 'Cancelada', value: 'Cancelada' },
      ],
      filteredValue: filteredInfo.Status || null,
      onFilter: (value, record) => record.Status === value,
    },
    {
      title: 'Cargos',
      dataIndex: 'Cargos',
      key: 'Cargos',
      width: 110,
      render: (cargos) => (
        <Badge 
          status={cargos === 'Tiene Cargos' ? 'success' : 'default'} 
          text={cargos}
        />
      ),
    },
    {
      title: 'F. Entrada',
      dataIndex: 'CHECKINDATE',
      key: 'CHECKINDATE',
      width: 120,
      render: (fecha, record) => (
        <Tooltip title="Click para editar">
          <Button 
            type="link" 
            size="small"
            icon={<CalendarOutlined />}
            onClick={() => handleEditarFecha('entrada', record)}
          >
            {fecha?.format('DD/MM/YYYY') || '-'}
          </Button>
        </Tooltip>
      ),
    },
    {
      title: 'F. Salida',
      dataIndex: 'CHECKOUTDATE',
      key: 'CHECKOUTDATE',
      width: 120,
      render: (fecha, record) => (
        <Tooltip title="Click para editar">
          <Button 
            type="link" 
            size="small"
            icon={<CalendarOutlined />}
            onClick={() => handleEditarFecha('salida', record)}
          >
            {fecha?.format('DD/MM/YYYY') || '-'}
          </Button>
        </Tooltip>
      ),
    },
    {
      title: 'F. Reserva',
      dataIndex: 'RESERVATION_DATE',
      key: 'RESERVATION_DATE',
      width: 120,
      render: (fecha) => fecha?.format('DD/MM/YYYY') || '-',
    },
    {
      title: 'Agencia',
      dataIndex: 'AGENCY',
      key: 'AGENCY',
      width: 130,
    },
    {
      title: 'Cliente',
      dataIndex: 'BOOKING_NAME',
      key: 'BOOKING_NAME',
      width: 180,
      render: (_, record) => {
          const nombreCompleto = [
            record.BOOKING_NAME,
            record.BOOKING_SURNAME1,
            record.BOOKING_SURNAME2
          ].filter(Boolean).join(' '); // Filtra valores nulos/vacíos y une con espacio
          
          return (
            <Space>
              <UserOutlined />
              <Text>{nombreCompleto || '-'}</Text>
            </Space>
          );
        },
    },
    {
      title: 'Pax',
      key: 'pax',
      width: 100,
      render: (_, record) => (
        <Space size={4}>
          <Tooltip title="Adultos">
            <Tag color="blue">{record.Adultos || 0}</Tag>
          </Tooltip>
          <Tooltip title="Niños">
            <Tag color="cyan">{record.Ninos || 0}</Tag>
          </Tooltip>
          <Tooltip title="Bebés">
            <Tag color="geekblue">{record.Bebes || 0}</Tag>
          </Tooltip>
        </Space>
      ),
    },
    {
      title: 'Importe',
      dataIndex: 'Importe',
      key: 'Importe',
      width: 120,
      align: 'right',
      sorter: (a, b) => (a.Importe || 0) - (b.Importe || 0),
      sortOrder: sortedInfo.columnKey === 'Importe' && sortedInfo.order,
      render: (importe) => (
        <Text strong style={{ color: '#52c41a' }}>
          {importe?.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}
        </Text>
      ),
    },
    {
      title: 'Descargada',
      dataIndex: 'Descargada',
      key: 'Descargada',
      width: 120,
      filters: [
        { text: 'Marcadas', value: 'Desmarcar' },
        { text: 'No Marcadas', value: 'Marcar' },
      ],
      filteredValue: filteredInfo.Descargada || null,
      onFilter: (value, record) => record.Descargada === value,
      render: (text, record) => (
        <Button
          type={text === 'Desmarcar' ? 'primary' : 'default'}
          danger={text === 'Desmarcar'}
          size="small"
          onClick={() => handleMarcarDesmarcar(record)}
          style={{ 
            backgroundColor: text === 'Desmarcar' ? '#52c41a' : undefined,
            borderColor: text === 'Desmarcar' ? '#52c41a' : undefined,
            color: text === 'Desmarcar' ? '#fff' : undefined
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: 120,
      fixed: 'right',
      render: (_, record) => (
        <Space>
          <Tooltip title="Ver detalles">
            <Button
              type="default"
              icon={<EyeOutlined />}
              size="small"
              onClick={() => handleVerReserva(record)}
            />
          </Tooltip>
          
          <Popconfirm
            title="¿Eliminar reserva?"
            description="Esta acción eliminará la reserva y todas sus líneas permanentemente"
            onConfirm={() => handleEliminarReserva(record)}
            okText="Sí"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Tooltip title="Eliminar">
              <Button
                danger
                icon={<DeleteOutlined />}
                size="small"
              />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // Estadísticas
  const estadisticas = (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      <Col span={4}>
        <Statistic 
          title="Total Reservas" 
          value={estadisticas2.total}
          prefix={<HomeOutlined />}
          valueStyle={{ color: '#1890ff' }}
        />
      </Col>
      <Col span={4}>
        <Statistic 
          title="Nuevas" 
          value={estadisticas2.nuevas}
          prefix={<CheckCircleOutlined />}
          valueStyle={{ color: '#52c41a' }}
        />
      </Col>
      <Col span={4}>
        <Statistic 
          title="Modificadas" 
          value={estadisticas2.modificadas}
          prefix={<EditOutlined />}
          valueStyle={{ color: '#fa8c16' }}
        />
      </Col>
      <Col span={4}>
        <Statistic 
          title="Canceladas" 
          value={estadisticas2.canceladas}
          prefix={<CloseCircleOutlined />}
          valueStyle={{ color: '#ff4d4f' }}
        />
      </Col>
      <Col span={4}>
        <Statistic 
          title="Marcadas" 
          value={estadisticas2.marcadas}
          prefix={<FilterOutlined />}
          valueStyle={{ color: '#722ed1' }}
        />
      </Col>
      {/* <Col span={4}>
        <Statistic 
          title="Importe Total" 
          value={reservas.reduce((sum, r) => sum + (r.Importe || 0), 0)}
          prefix={<DollarOutlined />}
          precision={2}
          suffix="€"
          valueStyle={{ color: '#13c2c2' }}
        />
      </Col> */}
    </Row>
  );

  // Panel de filtros
  const filtrosPanel = (
    <Card 
      size="small" 
      title={
        <Space>
          <FilterOutlined />
          <Text strong>Filtros de Búsqueda</Text>
        </Space>
      }
      style={{ marginBottom: 16 }}
    >
      <Row gutter={[16, 16]}>
        
          <Col span={24}>
            <Text strong>Hoteles:</Text>
            <Select
              mode="multiple"
              style={{ width: '100%', marginTop: 8 }}
              placeholder="Seleccionar hoteles..."
              value={hotelesSeleccionados}
              onChange={setHotelesSeleccionados}
              options={hoteles}
              allowClear
            />
          </Col>
        
            

        <Col span={6}>
          <Text strong>F. Entrada:</Text>
          <Space style={{ marginTop: 8 }}>
            <DatePicker
              placeholder="Desde"
              value={fechaEntradaDesde}
              onChange={setFechaEntradaDesde}
              format="DD/MM/YYYY"
              style={{ width: 140 }}
            />
            <DatePicker
              placeholder="Hasta"
              value={fechaEntradaHasta}
              onChange={setFechaEntradaHasta}
              format="DD/MM/YYYY"
              style={{ width: 140 }}
            />
          </Space>
        </Col>

        <Col span={6}>
          <Text strong>F. Salida:</Text>
          <Space style={{ marginTop: 8 }}>
            <DatePicker
              placeholder="Desde"
              value={fechaSalidaDesde}
              onChange={setFechaSalidaDesde}
              format="DD/MM/YYYY"
              style={{ width: 140 }}
            />
            <DatePicker
              placeholder="Hasta"
              value={fechaSalidaHasta}
              onChange={setFechaSalidaHasta}
              format="DD/MM/YYYY"
              style={{ width: 140 }}
            />
          </Space>
        </Col>

        <Col span={6}>
          <Text strong>F. Reserva:</Text>
          <Space style={{ marginTop: 8 }}>
            <DatePicker
              placeholder="Desde"
              value={fechaReservaDesde}
              onChange={setFechaReservaDesde}
              format="DD/MM/YYYY"
              style={{ width: 140 }}
            />
            <DatePicker
              placeholder="Hasta"
              value={fechaReservaHasta}
              onChange={setFechaReservaHasta}
              format="DD/MM/YYYY"
              style={{ width: 140 }}
            />
          </Space>
        </Col>

        <Col span={6}>
          <Text strong>Nº Reserva:</Text>
          <Space style={{ marginTop: 8 }}>
            <Input
              placeholder="Desde"
              value={reservaDesde}
              onChange={(e) => setReservaDesde(e.target.value)}
              style={{ width: 120 }}
            />
            <Input
              placeholder="Hasta"
              value={reservaHasta}
              onChange={(e) => setReservaHasta(e.target.value)}
              style={{ width: 120 }}
            />
          </Space>
        </Col>

        <Col span={6}>
          <Text strong>Localizador:</Text>
          <Input
            placeholder="Buscar por localizador..."
            value={localizador}
            onChange={(e) => setLocalizador(e.target.value)}
            style={{ marginTop: 8, width: '100%' }}
            allowClear
          />
        </Col>

        <Col span={6}>
          <Text strong>Marcadas:</Text>
          <Select
            value={marcadas}
            onChange={setMarcadas}
            style={{ marginTop: 8, width: '100%' }}
          >
            <Option value="todas">Todas</Option>
            <Option value="si">Sí</Option>
            <Option value="no">No</Option>
          </Select>
        </Col>

        <Col span={24}>
          <Space>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={buscarReservas}
              loading={loading}
              size="large"
            >
              Buscar
            </Button>
            <Button
              icon={<ReloadOutlined />}
              onClick={handleResetFiltros}
            >
              Restablecer Filtros
            </Button>
          </Space>
        </Col>
      </Row>
    </Card>
  );

  return (
    <>
      <PageContainer
        title="Búsqueda de Reservas XML"
        subtitle={`${reservas.length} reservas encontradas`}
        icon={<SearchOutlined />}
        loading={loading}
        onRefresh={buscarReservas}
        badgeCount={reservas.length}
        badgeStatus="processing"
        extra={
          <Space>
            <Button
              icon={<ExportOutlined />}
              onClick={() => message.info('Exportación en desarrollo')}
            >
              Exportar
            </Button>
          </Space>
        }
        cardStyle={{
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
        }}
      >
        {/* Panel de filtros */}
        {filtrosPanel}

        {/* Estadísticas */}
        {estadisticas}

        {/* Tabla de resultados */}
        <Table
          columns={columns}
          dataSource={reservas}
          rowKey={(record) => record.IdReserva}
          loading={loading}
          onChange={handleTableChange}
          scroll={{ x: 2000, y: 500 }}
          size="middle"
          pagination={{
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} reservas`,
            pageSizeOptions: ['10', '20', '50', '100']
          }}
          locale={{
            emptyText: 'No se encontraron reservas'
          }}
          rowClassName={(record) => 
            record.Descargada === 'Desmarcar' ? 'reserva-marcada' : ''
          }
        />
      </PageContainer>

{/* Modal para ver detalles de la reserva */}
<Modal
  title={
    <Space>
      <EyeOutlined />
      <Text strong>Detalles de la Reserva</Text>
    </Space>
  }
  open={modalVerVisible}
  onCancel={() => {
    setModalVerVisible(false);
    setReservaSeleccionada(null);
    setLineasReserva([]);
    setPreciosReserva([]);
  }}
  footer={[
    <Button key="close" onClick={() => setModalVerVisible(false)}>
      Cerrar
    </Button>,
    <Button 
      key="edit" 
      type="primary" 
      icon={<EditOutlined />}
      onClick={() => {
        setModalVerVisible(false);
        // Navegar a edición si es necesario
        message.info('Edición en desarrollo');
      }}
    >
      Editar Reserva
    </Button>
  ]}
  width={900}
  style={{ top: 20 }}
>
  <Spin spinning={loadingDetalle}>
    {reservaSeleccionada && (
      <div>
        {/* Información principal */}
        <Card size="small" style={{ marginBottom: 16 }}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <Text type="secondary">ID Reserva:</Text>
              <br />
              <Text strong>{reservaSeleccionada.ReservaAnphitrion}</Text>
            </Col>
            <Col span={8}>
              <Text type="secondary">Localizador:</Text>
              <br />
              <Tag color="purple" icon={<BarcodeOutlined />}>
                {reservaSeleccionada.LOCATION_NUMBER}
              </Tag>
            </Col>
            <Col span={8}>
              <Text type="secondary">Hotel:</Text>
              <br />
              <Tag color="blue" icon={<HomeOutlined />}>
                {reservaSeleccionada.NombreHotel}
              </Tag>
            </Col>
            <Col span={8}>
              <Text type="secondary">Estado:</Text>
              <br />
              <Tag color={reservaSeleccionada.Status === 'Nueva' ? 'green' : reservaSeleccionada.Status === 'Modificada' ? 'orange' : 'red'}>
                {reservaSeleccionada.Status}
              </Tag>
            </Col>
            <Col span={8}>
              <Text type="secondary">Cliente:</Text>
              <br />
              <Text strong>{reservaSeleccionada.BOOKING_NAME || '-'} {reservaSeleccionada.BOOKING_SURNAME1 || '-'}</Text>
            </Col>
            <Col span={8}>
              <Text type="secondary">Email:</Text>
              <br />
              <Text>{reservaSeleccionada.BOOKING_EMAIL || '-'}</Text>
            </Col>
            <Col span={8}>
              <Text type="secondary">Teléfono:</Text>
              <br />
              <Text>{reservaSeleccionada.BOOKING_PHONE || '-'}</Text>
            </Col>
            <Col span={8}>
              <Text type="secondary">Agencia:</Text>
              <br />
              <Text>{reservaSeleccionada.AGENCY || '-'}</Text>
            </Col>
            <Col span={8}>
              <Text type="secondary">Importe:</Text>
              <br />
              <Text strong style={{ color: '#52c41a', fontSize: '16px' }}>
                {reservaSeleccionada.Importe?.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}
              </Text>
            </Col>
            <Col span={8}>
              <Text type="secondary">Pax:</Text>
              <br />
              <Space>
                <Tag color="blue">A: {reservaSeleccionada.Adultos || 0}</Tag>
                <Tag color="cyan">N: {reservaSeleccionada.Ninos || 0}</Tag>
                <Tag color="geekblue">B: {reservaSeleccionada.Bebes || 0}</Tag>
              </Space>
            </Col>
            <Col span={8}>
              <Text type="secondary">F. Entrada:</Text>
              <br />
              <Text>{reservaSeleccionada.CHECKINDATE?.format('DD/MM/YYYY') || '-'}</Text>
            </Col>
            <Col span={8}>
              <Text type="secondary">F. Salida:</Text>
              <br />
              <Text>{reservaSeleccionada.CHECKOUTDATE?.format('DD/MM/YYYY') || '-'}</Text>
            </Col>
            <Col span={8}>
              <Text type="secondary">F. Reserva:</Text>
              <br />
              <Text>{reservaSeleccionada.RESERVATION_DATE?.format('DD/MM/YYYY') || '-'}</Text>
            </Col>
            <Col span={8}>
              <Text type="secondary">Cargos:</Text>
              <br />
              <Badge 
                status={reservaSeleccionada.Cargos === 'Tiene Cargos' ? 'success' : 'default'} 
                text={reservaSeleccionada.Cargos}
              />
            </Col>
            <Col span={8}>
              <Text type="secondary">Descargada:</Text>
              <br />
              <Button
                type={reservaSeleccionada.Descargada === 'Desmarcar' ? 'primary' : 'default'}
                size="small"
                style={{ 
                  backgroundColor: reservaSeleccionada.Descargada === 'Desmarcar' ? '#52c41a' : undefined,
                  pointerEvents: 'none'
                }}
              >
                {reservaSeleccionada.Descargada}
              </Button>
            </Col>
          </Row>
        </Card>

        {/* Líneas de la reserva */}
        <Card title="Líneas de Reserva" size="small" style={{ marginBottom: 16 }}>
          <Table
            dataSource={lineasReserva}
            rowKey="AutoCodigo"
            size="small"
            pagination={false}
            columns={[
              { title: 'Habitación', dataIndex: 'room_Type', key: 'room_Type', width: 150 },
              { title: 'Board', dataIndex: 'BOARD', key: 'BOARD', width: 100 },
              { title: 'Llegada', dataIndex: 'ARRIVAL_DATE', key: 'ARRIVAL_DATE', width: 110, render: (date) => dayjs(date).format('DD/MM/YYYY') },
              { title: 'Salida', dataIndex: 'DEPARTURE_DATE', key: 'DEPARTURE_DATE', width: 110, render: (date) => dayjs(date).format('DD/MM/YYYY') },
              { title: 'Adultos', dataIndex: 'ADULTS', key: 'ADULTS', width: 70, align: 'center' },
              { title: 'Niños', dataIndex: 'CHILDS', key: 'CHILDS', width: 70, align: 'center' },
              { title: 'Bebés', dataIndex: 'BABIES', key: 'BABIES', width: 70, align: 'center' },
              { title: 'Tarifa', dataIndex: 'FARECODE', key: 'FARECODE', width: 100 },
              { title: 'Cliente', dataIndex: 'NombreCliente', key: 'NombreCliente', width: 150 },
            ]}
            scroll={{ x: 900 }}
          />
        </Card>

        {/* Precios de la reserva */}
        <Card title="Desglose de Precios" size="small">
          <Table
            dataSource={preciosReserva}
            rowKey="AutoCodigo"
            size="small"
            pagination={false}
            columns={[
              { title: 'Fecha', dataIndex: 'Fecha', key: 'Fecha', width: 120, align: 'center' },
              { title: 'Línea', dataIndex: 'Linea', key: 'Linea', width: 80, align: 'center' },
              { 
                title: 'Precio', 
                dataIndex: 'Precio', 
                key: 'Precio', 
                width: 120, 
                align: 'right',
                render: (precio) => (
                  <Text strong style={{ color: '#52c41a' }}>
                    {precio?.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}
                  </Text>
                )
              },
            ]}
            footer={() => (
              <Row justify="end">
                <Col>
                  <Text strong>Total: </Text>
                  <Text strong style={{ color: '#52c41a', fontSize: '16px' }}>
                    {preciosReserva.reduce((sum, p) => sum + (p.Precio || 0), 0).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}
                  </Text>
                </Col>
              </Row>
            )}
          />
        </Card>
      </div>
    )}
  </Spin>
</Modal>      

      {/* Modal para editar fecha */}
      <Modal
        title={`Editar Fecha de ${fechaEditando.tipo === 'entrada' ? 'Entrada' : 'Salida'}`}
        open={modalFechaVisible}
        onOk={handleGuardarFecha}
        onCancel={() => setModalFechaVisible(false)}
        okText="Guardar"
        cancelText="Cancelar"
      >
        <Form form={formFecha} layout="vertical">
          <Form.Item
            name="fecha"
            label="Fecha"
            rules={[{ required: true, message: 'Seleccione una fecha' }]}
          >
            <DatePicker 
              style={{ width: '100%' }} 
              format="DD/MM/YYYY"
            />
          </Form.Item>
        </Form>
      </Modal>

      {/* Estilos CSS */}
      <style jsx>{`
        .reserva-marcada {
          background-color: #f6ffed !important;
        }
        .ant-table-row:hover > td {
          background-color: #e6f7ff !important;
        }
      `}</style>
    </>
  );
};

export default BusquedaReservasXML;